import { render, staticRenderFns } from "./HonorarioDetalle.vue?vue&type=template&id=65e087f6&scoped=true&"
import script from "./HonorarioDetalle.vue?vue&type=script&lang=js&"
export * from "./HonorarioDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e087f6",
  null
  
)

export default component.exports